import { render, staticRenderFns } from "./ReviewReport.vue?vue&type=template&id=368fd447&"
import script from "./ReviewReport.vue?vue&type=script&lang=js&"
export * from "./ReviewReport.vue?vue&type=script&lang=js&"
import style0 from "./ReviewReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports